import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import footerLogo from "../../img/footer_logo.png";
import instaLogo from "../../img/footer_insta.png";
import Slide from '@material-ui/core/Slide';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';

const useStyles = makeStyles((theme) => ({
    appBar: {
        top: 'auto',
        bottom: 0,
    },

    footer: {
        padding: "30px 0 30px 0",
        backgroundColor: "#222222",
        //display: "flex",
        width: "100%",
        // bottom: theme.spacing(2)
        //   position: "fixed"
    },
    footerContainer: {

        display: "flex",

        "@media (max-width: 770px)": {
            display: "inline",
        }


    },

    item1: {
        flex: "left",
        margin: "0px 40px 0px 100px",
        "@media (max-width: 770px)": {
            margin: "10px",
            width: "20%"
        }

    },
    itme2: {
        color: "#fff",
        alignSelf: "center"
    },
    item3: {
        color: "#fff",
        alignSelf: "center",
        width: "70%",
        "@media (max-width: 770px)": {
            width: "auto"
        }


    },
    item4: {
        float: "right",
        marginRight: "10px",
        "@media (max-width: 770px)": {
            float: "left",
            width: "10%"
        }

    },



}))
function HideOnScroll(props) {
    const { children, window } = props;
    console.log(props)
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        target: window ? window() : undefined,
        threshold: 1300
    });

    return (
        <Slide
            appear={false}
            direction="up"
            in={trigger}>
            {children}
        </Slide>
    );
}

const Footer = () => {

    const style = useStyles();

    return (
        // <HideOnScroll>
        // <AppBar className={style.appBar}position="fixed">
        <div className={style.footer}>
            <div className={style.footerContainer}>

                <img className={style.item1} src={footerLogo} alt="logo" />
                <div className={style.itme2}>
                    Surbay.official@gmail.com<br />
                    © 2021 SurBay®
                </div>

                <div className={style.item3}>
                    <img className={style.item4} src={instaLogo} style={{ width: "30px", height: "30px" }} alt="logo" />
                    <span className={style.item4}>
                        @surbay_official
                    </span>
                </div>
            </div>
        </div>
        // </AppBar>
        // </HideOnScroll>
    );
};

export default Footer;